import L from "leaflet";
import tr from '../i18n';

L.drawLocal.draw.toolbar.actions = { text: tr("Cancel"), title: tr("Cancel Drawing") };
L.drawLocal.draw.toolbar.finish = { text: tr("Finish"), title: tr("Finish Drawing") };
L.drawLocal.draw.toolbar.undo = { text: tr("Delete Last Point"), title: tr("Delete Last Point") };
L.drawLocal.draw.toolbar.buttons.polygon = tr("Draw Polygon");
L.drawLocal.draw.handlers.polygon = {
  tooltip: {
    cont: tr("Click to draw a polygon"),
    end: tr("Click the first point or click Finish to close the polygon"),
    start: tr("Select a point to start drawing"),
  },
};
L.drawLocal.edit.toolbar.actions = {
  cancel: { text: tr("Cancel"), title: tr("Cancel Editing") },
  clearAll: { text: tr("Delete All"), title: tr("Delete All Shapes") },
  save: { text: tr("Save"), title: tr("Save Changes") },
};
L.drawLocal.edit.handlers.edit = {
  tooltip: {
    subtext: tr("Click Save to save the changes."),
    text: tr("Drag the vertices to edit the shape."),
  },
};
L.drawLocal.edit.handlers.remove = {
  tooltip: { text: tr("Select a polygon to delete") },
};
